import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrentImg from "../../../../../components/common/SelectingWarrentImg"



const LastTradedPrices = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("")

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='last_trade Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }}>Previous Topic</div>
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Monitoring price changes</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>Monitoring price changes</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Last Traded prices</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div className="nextlbl right">
                                                                <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                                <div className="nextname " style={{ textAlign: 'right' }}>Bid prices</div>
                                                            </div>
                                                        </td>
                                                        <td width="33px"><div className="next right" /></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .imgholder img{\n                max-width: 740px; \n/*                max-height: 247px; */\n/*                width: 80%; \n                height: 80%;*/\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>
                                                In order to track the price changes of listed securities, information sources such as the media, brokers and online providers will typically publish the “daily price change” for shares/warrants, comparing of the current traded price versus its closing price the day before.<br /><br /> However, with warrants, this method is often totally inaccurate as warrants do not trade as frequently as shares. Therefore the price that is listed as the warrant’s “previous close” may actually relate to a trade that happened the previous morning, two days earlier, or even weeks ago.
                                            </p>
                                            <div className="imgholder">
                                                <img src='/img/education/trackingwarrantspricechangelastprice.png' alt="image" />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() =>{ return setOpenLive(true), setImageUrl("/img/education/trackingwarrantspricechangelastpriceMob.png")}}
                                                    >View table
                                                    </div>
                                                </div>

                                            </div>
                                            <p>
                                                The above chart is an example drawn by using the last prices of a share and a corresponding call warrant. You will notice the circled portions of the chart show that the ‘recorded’ warrant price has remained unchanged despite movements in the underlying share price. This is because during those periods even though the warrant’s bid and offer prices have moved up and down with the underlying share price, the warrant did not record a trade, and thus continued displaying the same price under its “last traded price”.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >

                                            <Link to="/edu/monitoring-price-changes/bid-price">
                                                Bid prices
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/monitoring-price-changes/bid-price">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/monitoring-price-changes">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/monitoring-price-changes">
                                                Monitoring price changes
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl} />

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>


        </div>
    );
}
export default LastTradedPrices;